module.exports = __webpack_public_path__ + "static/media/enabledPreviousIcon.2d69c137.svg";